$('.in-index .products').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 }},
    { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 1 }},
    { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows:false, dots:true }},
    { breakpoint: 479,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:true }}
  ]
});

$('.type-detail .products').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 }},
    { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 1 }},
    { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows:false, dots:true }},
    { breakpoint: 479,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:true }}
  ]
});



function initSlick() {
  if ($(window).width() < 1200) {
    if (!$('.topBanners .topBannersInner').hasClass('slick-initialized')) {
      $('.topBanners .topBannersInner').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          { breakpoint: 991,  settings: { slidesToShow: 2 }},
          { breakpoint: 479,  settings: { slidesToShow: 1 }}
        ]
      });
    }
  } else {
    if ($('.topBanners .topBannersInner').hasClass('slick-initialized')) {
      $('.topBanners .topBannersInner').slick('unslick');
    }
  }
}

$(window).on('load resize', initSlick);